import * as React from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

import { focusVisibleRing, focusVisibleRingError } from './constants';

const inputVariants = cva(
  [
    'flex w-full min-w-0 rounded-md border border-border bg-background px-3 text-sm leading-5 transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground autofill:shadow-[inset_0_0_0_1000px_var(--background)] autofill:[-webkit-text-fill-color:var(--foreground)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
    focusVisibleRing,
    focusVisibleRingError,
  ],
  { defaultVariants: { size: 'md' }, variants: { size: { sm: 'h-9 py-2', md: 'h-10 py-2.5' } } }
);

export interface InputProps
  extends
    Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

const Input = ({
  className,
  type,
  size,
  ref,
  ...props
}: InputProps & { ref?: React.Ref<HTMLInputElement> }) => {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(inputVariants({ size }), className)}
      {...props}
    />
  );
};

export { Input };
